export default {
  setContainersData(state, containers) {
    state.containers.data = containers.data;
    if (containers.pagination) {
       const meta = Array.isArray(containers.pagination) ? containers.pagination[0] : containers.pagination;
       const paginationInfo = meta.page || meta;

       state.containers.pagination.total = paginationInfo.total_pages || paginationInfo.totalPages || paginationInfo.total || 1;
       state.containers.pagination.totalItems = paginationInfo.total_elements || paginationInfo.totalElements || paginationInfo.total_items || paginationInfo.totalItems || paginationInfo.count || containers.data.length;
       state.containers.pagination.initialItem = (paginationInfo.number || paginationInfo.page || 0) * (paginationInfo.size || 5);
    }
  }
}
